import { single } from '../calculators/single'
import { countConversationsCreated } from '../queries/countConversationsCreated'

export const conversationsCreatedForEachDayGauge = {
  calculate: single,
  queries: [
    {
      ...countConversationsCreated,
      interval: 'daily',
    },
  ],
  title: 'Conversations',
}
